import styled from 'styled-components/macro'

export const Container = styled.div<{ $fluid?: boolean }>`
  padding: 0 var(--container-spacing);
  width: 100%;
  max-width: calc(var(--container-width) + 2 * var(--container-spacing));
  margin: 0 auto;
  text-align: center;
`
